import { Controller } from "@hotwired/stimulus";

/**
 * Keeps Turbo's morph out of an element whose markup a third-party widget owns.
 *
 * Tom Select replaces a <select> with its own wrapper. Morphing the server's
 * plain markup over that strips the wrapper and leaves a dead instance behind,
 * and because the <select> node itself survives the morph, Stimulus never
 * reconnects to rebuild it. Cancelling the morph for this element leaves the
 * widget alone; refresh it with a plain turbo_stream replace instead, which
 * disconnects the controller and builds the widget again.
 *
 * Connect to: data-controller="morph-skip"
 */
export default class extends Controller {
  private guard = (event: Event) => {
    if (event.target === this.element) event.preventDefault();
  };

  connect() {
    document.addEventListener("turbo:before-morph-element", this.guard);
  }

  disconnect() {
    document.removeEventListener("turbo:before-morph-element", this.guard);
  }
}
